<template>
  <div class="">
    <div class="video-thumbnail rounded d-flex align-items-center" ref="thumbnail" @click="goToVideo()" @mouseover="thumbnailHeight">
      <img :src="thumbnail" class="rounded img-fluid" width="100%" height="100%" />
      <div v-if="duration" class="video-duration">
        {{ duration | videoDuration }}
      </div>
    </div>
    <div
      class="font-16 line-height-24 mt-2 ef-cursor-pointer"
      v-b-tooltip.hover
      boundary-padding="2"
      :title="title"
      @click="goToVideo()"
    >
      <b class="title-line-limit">{{ title }}</b>
    </div>
    <div class="font-12 line-height-18 text-gray my-2">
      <b>Exercise</b>
      <span class="px-2">&bull; </span>
      <span class="font-weight-500 font-12 line-height-18">{{getWorkoutIntensity(intensity)}}</span>
    </div>
    <label
      class="color-primary border-green px-2 px-lg-3 font-weight-500 rounded m-0 mr-1 mr-lg-2"
      v-for="(category, idx) in categories"
      :key="idx"
      >{{category}}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: { type: Number | String, default: null },
    title: { type: String, default: null },
    thumbnail: { type: String, default: null },
    duration: { type: Number | String, default: null },
    tenantName: { type: String, default: null },
    categories: { type: Array, default: null },
    intensity: { type: Number | String, default: null },
  },
  methods: {
    thumbnailHeight() {
      this.$emit("thumbnailHeight", this.$refs.thumbnail.clientHeight)
    },
    goToVideo() {
      this.$router.push(
        `/campaign/${this.$route.params.name}/safety-precautions?tenantName=${this.tenantName.replaceAll(/\s/g, "")}&id=${
          this.id
        }&tryNow=true`
      );
    },
    getWorkoutIntensity(intensity){
      if(!isNaN(+intensity) && +intensity <= 4.5){
        return "Beginner";
      }
      else if(!isNaN(+intensity) && +intensity <= 7.5 && +intensity >= 5){
        return "Intermediate";
      }
      else if(!isNaN(+intensity) && +intensity >= 8){
        return "Advanced";
      }
      else{
        return "";
      }
    }
  },
  filters: {
    videoDuration: function(time) {
      // Hours, minutes and seconds
      const hrs = ~~(time / 3600);
      const mins = ~~((time % 3600) / 60);
      const secs = ~~time % 60;

      // Output like "01:01" or "04:03:59" or "123:03:59"
      let ret = "";
      if (hrs > 0) {
        ret += "" + (hrs > 9 ? hrs : "0" + hrs) + ":";
      }
      ret += "" + (mins > 9 ? mins : "0" + mins) + ":";
      ret += "" + (secs > 9 ? secs : "0" + secs);
      return ret;
    },
  },
};
</script>

<style lang="scss" scoped>
.title-line-limit {
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.border-green {
  border: 1px solid;
  width: auto;
  border-color: #73bc44;
  font-size: 12px;
}
.video-thumbnail {
  cursor: pointer;
  position: relative;
  left: 0;
  top: 0;
  overflow: hidden;
  // width: 100%;
  // width: 325px;
  // height: 183px;
  aspect-ratio: 1.79; // width/height : 325/183
}
.video-duration {
  position: absolute;
  width: fit-content;
  right: 9px;
  bottom: 9px;
  text-align: center;
  color: #ffffff;
  background-color: #000000c9;
  border-radius: 2px;
  font-size: 13px;
  line-height: 18px;
  font-weight: bold;
  padding: 0 5px;
}

@media screen and (max-width: 768px) {
  .border-green {
    font-size: 10px;
  }
}
</style>
